
import React, {useState} from 'react';


function App({id, title}) {  

    return (
        <div className="">
            <div  id={id} className="hashtag text-underline text-title">{title}</div> 
        </div>
    );
}
    
    export default App;